export default "__VITE_ASSET__Dqt60x6I__"